import { TableCell } from '@mui/material';
import type React from 'react';
import type { TableHeadComponent } from '../../common/components/table/types';

export type EnabledIndicatorHeaderCellProps = Pick<TableHeadComponent, 'title'>;

const EnabledIndicatorHeaderCell: React.FC<EnabledIndicatorHeaderCellProps> = ({ title }) => (
  <TableCell width="40" sx={{ textWrap: 'nowrap' }}>
    {title}
  </TableCell>
);

export default EnabledIndicatorHeaderCell;
